import React, { createContext, useContext } from 'react'
import * as Interface from "api/interfaces/dashboardInterface.interface";
import UserLogin from "../card/UserLogin";
import ClientDevice from "../card/ClientDevice";
import Recorders from "../card/Recorders";
import Cameras from "../card/Cameras";
import Organization from "../card/Organization";
import BestPageView from "../card/BestPageView";
import RecordersChart from "../card/RecordersChart";
import SubscriptionKeys from "../card/SubscriptionKeys";
import Users from "../card/Users";
import SubscriptionStatus from "../card/SubscriptionStatus";
import ActiveAlert from "../card/ActiveAlert";
import VideoShare from "../card/VideoShare";
import CloudStorage from "../card/CloudStorage";
import * as s from "../StatsStyled";
import { RiDraggable } from 'react-icons/ri';
import CovaLicense from '../card/CovaLicense';
import ChannelLicense from '../card/ChannelLicense';
import EuLicense from '../card/EuLicense';
const StatsWidgetContext = createContext<Interface.WidgetContext>({
  chartId: "",
  onReplaceChart: () => {},
  onRemoveChart: () => {},
  hiddenCharts: [],
  onChangeGraphType: () => {},
  i: "",
  title: "",
  rows: [],
  items: [],
  graphType: "",
  lengedType: "",
  isRole: [],
  onToggleAddLayout: () => {},
  showAddRemove: false,
  includeSuspended: false,
});

const ChartComponent = {
    clientDevices: ClientDevice,
    userLogin: UserLogin,
    recorders: Recorders,
    cameras: Cameras,
    organization: Organization,
    spectrumRecorders: Recorders,
    covaRecorders: Recorders,
    vmaxA1Recorders: Recorders,
    vmaxIPRecorders: Recorders,
    bestPageView: BestPageView,
    Recorders: RecordersChart,
    subscriptionStatus: SubscriptionStatus,
    subscriptionKeys: SubscriptionKeys,
    Users: Users,
    activeAlert: ActiveAlert,
    videoShare: VideoShare,
    cloudStorage: CloudStorage,
    covaLicense: CovaLicense,
    channelLicense: ChannelLicense,
    euLicense: EuLicense,
  };
export const useStatsWidget = () => useContext(StatsWidgetContext);


function GridChartItem(props: Interface.GridChartItem) {
  const Chart = ChartComponent[props.item.i as keyof typeof ChartComponent];
  return (
    <StatsWidgetContext.Provider
      value={{
        ...props.item,
        onReplaceChart: props.onReplaceChart,
        onRemoveChart: props.onRemoveChart,
        hiddenCharts: props.hiddenCharts,
        onChangeGraphType: (type) =>
          props.onChangeGraphType(props.item.key, type),
        onToggleAddLayout: props.onToggleAddLayout,
        showAddRemove: props.showAddRemove,
        includeSuspended: props.includeSuspended,
        chartId: props.item.key,
      }}
    >
      <s.DragHandle className="drag-handle" data-testid={`drag-handle-${props.item.key}`}>
        <RiDraggable size={14} />
      </s.DragHandle>
      <Chart {...props.item} />
    </StatsWidgetContext.Provider>
  )
}

export default GridChartItem